import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import ClickOut from '~/js/components/global/ClickOut';

import Tooltip from './Tooltip';

const ScheduleTable = (props) => {
  const {
    cellClickedHandler,
    clickedCell,
    clickOutSide,
    closeTooltipHandler,
    scrollLeft,
    scrollRight,
    wrapRef,
    tableRef
  } = props;
  const { days, data } = props.data;

  const cleckedRow = clickedCell[0];
  const cleckedCell = clickedCell[1];
  const cleckedActivites = clickedCell[2];

  let thead;
  let tbody;

  if (days.length) {
    thead = (
      <thead>
        <tr>
          {days.map((day, index) =>
            <th key={index}>{day}</th>
          )}
        </tr>
      </thead>
    );
  }

  if (data.length) {
    tbody = data.map((row, rowIndex) => {

      return (
        <tr key={rowIndex}>
          {row.activities.map((el, cellIndex) => {
            const isTooltipOpen = (cleckedRow === rowIndex) && (cleckedCell === cellIndex);

            let activities;

            if (el && (el.length >= 1)) {

              activities = (
                el.map((activity, actIndex) => {
                  const isOpen = isTooltipOpen && (cleckedActivites === actIndex);

                  return (
                    <div
                      key={actIndex}
                      className={`activity ${activity.type}`}
                      onClick={() => cellClickedHandler(rowIndex, cellIndex, actIndex)}>
                      <div className="time">
                        {row.time}
                      </div>
                      <div className="label">
                        {activity.label}
                      </div>

                      {isOpen && activity.tooltip &&
                        <ClickOut callback={clickOutSide}>
                          <Tooltip
                            type={activity.type}
                            content={activity.tooltip}
                            closeHandler={closeTooltipHandler}/>
                        </ClickOut>
                      }
                    </div>
                  );
                })
              );
            }

            return (
              <td key={cellIndex}>
                {activities}
              </td>
            );

          })
          }
        </tr>
      );
    });
  }

  return(
    <Fragment>
      <div className="table-container">
        <div ref={wrapRef} className="table-wrap">
          <i className="prev icon-button-prev" onClick={scrollLeft}/>
          <table ref={tableRef}>
            {thead}
            <tbody>
              {tbody}
            </tbody>
          </table>
          <i className="next icon-button-next" onClick={scrollRight}/>
        </div>
      </div>

      <ul className="table-captions uppercase">
        <li className="relaxation">Relaxation Activities</li>
        <li className="water">Water Related Activities</li>
        <li className="physical">Physical Activities</li>
        <li className="field">Field Activities</li>
      </ul>
    </Fragment>
  );
};

ScheduleTable.propTypes = {
  data: PropTypes.object,
  clickedCell: PropTypes.array,
  cellClickedHandler: PropTypes.func
};

ScheduleTable.defaultProps = {
  data: {
    days: [],
    data: []
  },
  clickedCell: []
};

export default ScheduleTable;
